import { AnagraficaSocieta } from "./anagrafica-societa";
import { AnagraficaUtente } from "./anagrafica-utente";

export class RegistrazioneSocieta {
    utente: AnagraficaUtente = new AnagraficaUtente();
    societa: AnagraficaSocieta = new AnagraficaSocieta();
}